import { useEffect, useRef } from "react";
import { fetchReportExamProctoringBreach } from "../ExamsApi";

const BREACH_DEBOUNCE_MS = 1500;

const ActivityCheck = ({ exam_id, user_exam_id }) => {
    const lastReportRef = useRef(0);

    useEffect(() => {
        const reportBreach = () => {
            const now = Date.now();
            if (now - lastReportRef.current < BREACH_DEBOUNCE_MS) return;
            lastReportRef.current = now;
            fetchReportExamProctoringBreach({ exam_id, user_exam_id })
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                reportBreach()
            }
        };

        const handleBlur = () => {
            reportBreach()
        };

        const handleFullscreenChange = () => {
            const fsElement =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;

            if (!fsElement) {
                reportBreach()
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("blur", handleBlur);
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
        document.addEventListener("mozfullscreenchange", handleFullscreenChange);
        document.addEventListener("MSFullscreenChange", handleFullscreenChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("blur", handleBlur);
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
            document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
            document.removeEventListener("MSFullscreenChange", handleFullscreenChange);
        };
    }, [exam_id, user_exam_id]);

    return null;
};

export default ActivityCheck;
